import {
  SET_SAD_FILTERS,
  SET_SAD_FILTER,
  REMOVE_SAD_FILTER,
  RESET_SAD_FILTER,
} from 'actions/SalesActivityDashboardActions';

const initialState = {};

export default function salesActivityDashboard(state = initialState, action) {
  switch (action.type) {
    case SET_SAD_FILTERS: {
      let newState = { ...action.payload.filters };
      return newState;
    }

    case SET_SAD_FILTER: {
      let newState = { ...state };
      const { name, values } = action.payload;
      if (!values.length) {
        delete newState[name];
      } else {
        newState[name] = values;
      }

      return newState;
    }

    case REMOVE_SAD_FILTER: {
      let newState = { ...state };
      const { name, value } = action.payload;
      let values = newState[name].slice();
      values.splice(values.indexOf(value), 1);

      if (!values.length) {
        delete newState[name];
      } else {
        newState[name] = values;
      }

      return newState;
    }

    case RESET_SAD_FILTER: {
      return {};
    }
  }

  return state;
}
